import { useEffect, useState } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getAllFavoriteItems } from '@/redux/modules/favorites/favorites.selectors';
import { getItemSummariesForCatalog } from '@/redux/modules/item/summary/itemSummary.selectors';

import { useFindLiveItemIndex } from './useFindLiveItemIndex';

type Props = {
    catalogId: number;
    itemId: number;
};

type LotsRelativeFavoritesPosition = {
    [itemId: number]: number;
};

export const useCalculatedRelativeFavoritesPosition = ({ catalogId, itemId }: Props) => {
    const favoriteItems = useAppSelector((state) => getAllFavoriteItems(state));
    const items = useAppSelector((state) => getItemSummariesForCatalog(state, catalogId));
    const liveItemIndex = useFindLiveItemIndex({ catalogId, itemId });

    const [favoriteItemsLength, setFavoriteItemsLength] = useState(0);
    const [indexDifference, setIndexDifference] = useState(0);
    const [lotRelativeFavoritePositionObject, setLotRelativeFavoritePositionObject] =
        useState<LotsRelativeFavoritesPosition>({});

    useEffect(() => {
        let tempFavoritesObject: LotsRelativeFavoritesPosition = {};

        if (
            favoriteItems.length ||
            favoriteItemsLength !== favoriteItems.length ||
            (favoriteItems.length && indexDifference !== liveItemIndex)
        ) {
            favoriteItems.forEach((favoriteItemId) => {
                const favoriteItemIndex = items.findIndex((item) => item.itemId === favoriteItemId);
                if (favoriteItemIndex > liveItemIndex) {
                    tempFavoritesObject[favoriteItemId] = favoriteItemIndex - liveItemIndex;
                }
            });

            setLotRelativeFavoritePositionObject(tempFavoritesObject);
            setFavoriteItemsLength(favoriteItems.length);
            setIndexDifference(liveItemIndex);
        }
    }, [favoriteItems, liveItemIndex, items, favoriteItemsLength, indexDifference]);

    return lotRelativeFavoritePositionObject;
};
